import { render, staticRenderFns } from "./ModalRelatorioPdf.vue?vue&type=template&id=57b63fdd&"
import script from "./ModalRelatorioPdf.vue?vue&type=script&lang=js&"
export * from "./ModalRelatorioPdf.vue?vue&type=script&lang=js&"
import style0 from "./ModalRelatorioPdf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports